'use strict';

function ctrl($scope, Global, $sce)
{
    let model = this;
    $scope.global = Global;

    model.url = $sce.trustAsResourceUrl('https://cyr3con.mantix4.com/vulnerability-info');
}

ctrl.$inject = ['$scope', 'Global', '$sce'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/cyr3con.js
 **/